import Vue from 'vue';
import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VSelect,
  VList,
  VBtn,
  VBtnToggle,
  VCard,
  VIcon,
  VGrid,
  VToolbar,
  VTextarea,
  VForm,
  VProgressCircular,
  VSlider,
  VSubheader,
  transitions,
  VTabs,
  VImg,
  VDataTable,
  VOverflowBtn,
  VRadioGroup,
} from 'vuetify';
import 'vuetify/src/stylus/app.styl';
import { Scroll } from 'vuetify/es5/directives';

// eslint-disable-next-line import/prefer-default-export
export const theme = {
  primary: '#00bfa5',
  secondary: '#424242',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
};

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VSelect,
    VList,
    VBtn,
    VBtnToggle,
    VCard,
    VIcon,
    VGrid,
    VToolbar,
    VTextarea,
    VForm,
    VProgressCircular,
    VSlider,
    VSubheader,
    transitions,
    VTabs,
    VImg,
    VDataTable,
    VOverflowBtn,
    VRadioGroup,
  },
  directives: {
    Scroll,
  },
  theme,
  options: {
    customProperties: true,
  },
  iconfont: 'md',
});
